import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, AlertCircleIcon, LoaderIcon } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  // Check for pre-filled message from URL
  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('kontakt?')) {
      const params = new URLSearchParams(hash.split('?')[1]);
      const zprava = params.get('zprava');
      if (zprava) {
        setFormData(prev => ({
          ...prev,
          message: decodeURIComponent(zprava)
        }));
        const contactSection = document.getElementById('kontakt');
        if (contactSection) {
          contactSection.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }
    setStatus('loading');
    try {
      const response = await fetch('https://formsubmit.co/ajax/info@svatyvaclav.living', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
          _subject: `Poptávka z webu – ${formData.name}`,
          _template: 'table'
        })
      });
      if (!response.ok) throw new Error('Odeslání selhalo');
      setStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        message: ''
      });
      setTimeout(() => setStatus('idle'), 5000);
    } catch {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };
  return <section id="kontakt" className="py-24 bg-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-35">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-36">
            Kontaktujte nás
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-37">
            Máte zájem projekt Svatý Václav? Dejte nám vědět.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-38">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-39">
            <form className="space-y-6" onSubmit={handleSubmit} data-id="element-40">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-41">
                <div data-id="element-42">
                  <label htmlFor="name" className="block text-sm font-medium text-base-dark mb-2" data-id="element-43">
                    Jméno a příjmení
                  </label>
                  <input type="text" id="name" value={formData.name} onChange={handleChange} className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors" placeholder="Jan Novák" data-id="element-44" />
                </div>
                <div data-id="element-45">
                  <label htmlFor="phone" className="block text-sm font-medium text-base-dark mb-2" data-id="element-46">
                    Telefon
                  </label>
                  <input type="tel" id="phone" value={formData.phone} onChange={handleChange} className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors" placeholder="+420 123 456 789" data-id="element-47" />
                </div>
              </div>
              <div data-id="element-48">
                <label htmlFor="email" className="block text-sm font-medium text-base-dark mb-2" data-id="element-49">
                  E-mail
                </label>
                <input type="email" id="email" value={formData.email} onChange={handleChange} className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors" placeholder="jan.novak@email.cz" data-id="element-50" />
              </div>
              <div data-id="element-51">
                <label htmlFor="message" className="block text-sm font-medium text-base-dark mb-2" data-id="element-52">
                  Zpráva
                </label>
                <textarea id="message" rows={4} value={formData.message} onChange={handleChange} className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors resize-none" placeholder="Dobrý den, měl bych zájem o informace k bytu 3+kk..." data-id="element-53"></textarea>
              </div>

              <AnimatePresence mode="wait" data-id="element-54">
                {status === 'success' && <motion.div initial={{
                opacity: 0,
                y: -10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} className="flex items-center gap-3 bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-sm" data-id="element-55">
                    <CheckCircleIcon className="w-5 h-5 flex-shrink-0" data-id="element-56" />
                    <span className="text-sm" data-id="element-57">
                      Zpráva byla úspěšně odeslána. Ozveme se vám co nejdříve.
                    </span>
                  </motion.div>}
                {status === 'error' && <motion.div initial={{
                opacity: 0,
                y: -10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} className="flex items-center gap-3 bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-sm" data-id="element-58">
                    <AlertCircleIcon className="w-5 h-5 flex-shrink-0" data-id="element-59" />
                    <span className="text-sm" data-id="element-60">
                      Vyplňte prosím jméno, e-mail a zprávu.
                    </span>
                  </motion.div>}
              </AnimatePresence>

              <button type="submit" disabled={status === 'loading'} className="w-full bg-primary hover:bg-primary-light text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide mb-[0px] mt-[50px] disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-61">
                {status === 'loading' ? <>
                    <LoaderIcon className="w-5 h-5 animate-spin" data-id="element-62" />
                    Odesílání...
                  </> : 'Odeslat zprávu'}
              </button>
            </form>
          </motion.div>

          {/* Developer Info */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative bg-primary-dark text-white p-10 rounded-2xl flex flex-col overflow-hidden shadow-xl h-full" data-id="element-63">
            {/* Background Image */}
            <img src="https://cdn.magicpatterns.com/uploads/p1jZefST6qKiRGW7GWUgDS/2.png" alt="Komerční prostory" className="absolute inset-0 w-full h-full object-cover opacity-30 mix-blend-luminosity" data-id="element-64" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-dark via-primary-dark/90 to-primary-dark/40" data-id="element-65"></div>

            {/* Logo - positioned right */}
            <img src="https://cdn.magicpatterns.com/uploads/sNU8T2jD7B667L431En3YD/bramal_logo.svg" alt="BRAMAL PROJECT" className="absolute z-10 right-8 top-[62px] h-[90px] w-auto opacity-80" data-id="element-66" />

            <div className="relative z-10" data-id="element-67">
              <span className="text-accent text-sm font-medium tracking-widest uppercase mb-4 block" data-id="element-68">
                Developer projektu
              </span>
              <p className="text-sm text-white/60 tracking-wider mb-8" data-id="element-69">
                BRAMAL PROJECT s.r.o.
              </p>

              <div className="space-y-6 text-white/80" data-id="element-70">
                <div data-id="element-71">
                  <p className="text-sm text-white/50 mb-1" data-id="element-72">Adresa projektu</p>
                  <p className="text-lg" data-id="element-73">
                    Dolní Jirčany
                    <br data-id="element-74" />
                    Praha-západ
                  </p>
                </div>
                <div data-id="element-75">
                  <p className="text-sm text-white/50 mb-1" data-id="element-76">Telefon</p>
                  <p className="text-lg" data-id="element-77">+420 602 304 915</p>
                </div>
                <div data-id="element-78">
                  <p className="text-sm text-white/50 mb-1" data-id="element-79">E-mail</p>
                  <p className="text-lg" data-id="element-80">info@svatyvaclav.living</p>
                </div>
              </div>
            </div>

            <div className="relative z-10 mt-auto pt-8 border-t border-white/10" data-id="element-81">
              <p className="text-sm text-white/60 italic" data-id="element-82">
                Dům u Sv. Václava je jediný projekt developera BRAMAL PROJECT
                s.r.o.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}